import Icon from '../../icon/icon';
import './multi-card.scss';


// TODO: fix so checkbox used instead of button, alt. ref


const MultiCard = (props) => {

    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        type,
        selected,
        add, 
        remove,
        onAdd, 
        onRemove, 
        ...inputProps // TODO: Remove style and classname??
    } = props
    

    const onClick = () => {
        if (selected) {
            remove(
                props.value
            )
        }
        else {
            add(
                props.value
        )}
    }
  
   return(
            <div
                htmlFor={`${props.name}.${props.value}`}
                onClick={onClick}
                className={`card-select card xs clickable elevated level-0 multi-card  ${selected ? 'selected level-4' : ''}`} >
              
                <div className="" style={{  paddingBottom: "8px", alignSelf: "flex-start"}} >
                    
                    <label className={`input input-${type === "checkbox" ? "checkbox" : "radio"}`} tabIndex="0" {...inputProps}>
                        <div className="group" style={{display:"flex", justifyContent:"flex-start", alignItems:"flex-start", gap:"var(--space-2)"}}>
                  
                                  
                            <h4 className="label-inline text lead " style={{display:"flex", textWrap:"wrap", gap:"var(--space-2)"}}><Icon icon={props.icon}  size="large" />{props.label}</h4>
                        </div>

                    </label>
                    
                </div>
                {props.description &&
                    <div style={{ paddingBottom: "20px",  paddingLeft: "0px", flexGrow:"2" }} >
                        <div className='text base' style={{ textWrap:"wrap"}} dangerouslySetInnerHTML={{ __html: props.description }} />
                    </div>
                }
               {selected &&
                props.children
               }
                <div className='multi-card--footer ' >
                    <button type="button" className={`select-btn ${selected ? 'selected':''}`}  >{selected ? 'Ta bort' : 'Lägg till'}</button>
                </div>

            </div>

        )
    
}

export default MultiCard;